export const LOGIN = {
  USER_LOGIN: "USER_LOGIN",
  USER_LOGIN_SUCCESS: "USER_LOGIN_SUCCESS",
  USER_LOGIN_FAIL: "USER_LOGIN_FAIL",

  USER_LOGOUT: "USER_LOGOUT",
}

export const GET_BRANCH_LIST = "GET_BRANCH_LIST";
export const GET_BRANCH_LIST_SUCCESS = "GET_BRANCH_LIST_SUCCESS";
export const GET_BRANCH_LIST_FAIL = "GET_BRANCH_LIST_FAIL";

export const CHANGE_ORDER_WAREHOUSE = "CHANGE_ORDER_WAREHOUSE";
export const CHANGE_ORDER_WAREHOUSE_SUCCESS = "CHANGE_ORDER_WAREHOUSE_SUCCESS";
export const CHANGE_ORDER_WAREHOUSE_FAIL = "CHANGE_ORDER_WAREHOUSE_FAIL";

export const GET_WAREHOUSE_PATTERN = "GET_WAREHOUSE_PATTERN";
export const GET_WAREHOUSE_PATTERN_SUCCESS = "GET_WAREHOUSE_PATTERN_SUCCESS";
export const GET_WAREHOUSE_PATTERN_FAIL = "GET_WAREHOUSE_PATTERN_FAIL";

export const REMOVE_DISPATCH_HISTORY = "REMOVE_DISPATCH_HISTORY";
export const REMOVE_DISPATCH_HISTORY_SUCCESS = "REMOVE_DISPATCH_HISTORY_SUCCESS";
export const REMOVE_DISPATCH_HISTORY_FAIL = "REMOVE_DISPATCH_HISTORY_FAIL";

export const REMOVE_SORTING_HISTORY = "REMOVE_SORTING_HISTORY";
export const REMOVE_SORTING_HISTORY_SUCCESS = "REMOVE_SORTING_HISTORY_SUCCESS";
export const REMOVE_SORTING_HISTORY_FAIL = "REMOVE_SORTING_HISTORY_FAIL";

export const OPERATION_LOG = "OPERATION_LOG";
export const OPERATION_LOG_SUCCESS = "OPERATION_LOG_SUCCESS";
export const OPERATION_LOG_FAIL = "OPERATION_LOG_FAIL";

export const GET_BATCH = 'GET_BATCH';
export const GET_BATCH_SUCCESS = 'GET_BATCH_SUCCESS';
export const GET_BATCH_FAIL = 'GET_BATCH_FAIL';

export const GET_STAFF_LIST = 'GET_STAFF_LIST';
export const GET_STAFF_LIST_SUCCESS = 'GET_STAFF_LIST_SUCCESS';
export const GET_STAFF_LIST_FAIL = 'GET_STAFF_LIST_FAIL';

export const GET_BATCH_ORDER = 'GET_BATCH_ORDER';
export const GET_BATCH_ORDER_SUCCESS = 'GET_BATCH_ORDER_SUCCESS';
export const GET_BATCH_ORDER_FAIL = 'GET_BATCH_ORDER_FAIL';

export const CREATE_SUB_BATCH = 'CREATE_SUB_BATCH';
export const CREATE_SUB_BATCH_SUCCESS = 'CREATE_SUB_BATCH_SUCCESS';
export const CREATE_SUB_BATCH_FAIL = 'CREATE_SUB_BATCH_FAIL';

export const GET_DIRECTION = "GET_DIRECTION";
export const GET_DIRECTION_SUCCESS = "GET_DIRECTION_SUCCESS";
export const GET_DIRECTION_FAIL = "GET_DIRECTION_FAIL";

export const GET_DISTRICT = "GET_DISTRICT";
export const GET_DISTRICT_SUCCESS = "GET_DISTRICT_SUCCESS";
export const GET_DISTRICT_FAIL = "GET_DISTRICT_FAIL";

export const GET_EXPIRATION_TYPE = "GET_EXPIRATION_TYPE";
export const GET_EXPIRATION_TYPE_SUCCESS = "GET_EXPIRATION_TYPE_SUCCESS";
export const GET_EXPIRATION_TYPE_FAIL = "GET_EXPIRATION_TYPE_FAIL";

export const UPDATE_EXPIRATION_TYPE = "UPDATE_EXPIRATION_TYPE";
export const UPDATE_EXPIRATION_TYPE_SUCCESS = "UPDATE_EXPIRATION_TYPE_SUCCESS";
export const UPDATE_EXPIRATION_TYPE_FAIL = "UPDATE_EXPIRATION_TYPE_FAIL";

export const GET_PARTNERS = "GET_PARTNERS";
export const GET_PARTNERS_SUCCESS = "GET_PARTNERS_SUCCESS";
export const GET_PARTNERS_FAIL = "GET_PARTNERS_FAIL";

export const ASSIGN_ORDER = "ASSIGN_ORDER";
export const ASSIGN_ORDER_SUCCESS = "ASSIGN_ORDER_SUCCESS";
export const ASSIGN_ORDER_FAIL = "ASSIGN_ORDER_FAIL";

export const GET_DRIVER_ORDER_COUNT = "GET_DRIVER_ORDER_COUNT"
export const GET_DRIVER_ORDER_COUNT_SUCCESS = "GET_DRIVER_ORDER_COUNT_SUCCESS"
export const GET_DRIVER_ORDER_COUNT_FAIL = "GET_DRIVER_ORDER_COUNT_FAIL"

export const GET_ZIPCODE_PATTERN = "GET_ZIPCODE_PATTERN"
export const GET_ZIPCODE_PATTERN_SUCCESS = "GET_ZIPCODE_PATTERN_SUCCESS"
export const GET_ZIPCODE_PATTERN_FAIL = "GET_ZIPCODE_PATTERN_FAIL"

export const GET_DRIVER_ORDERS = "GET_DRIVER_ORDERS"
export const GET_DRIVER_ORDERS_SUCCESS = "GET_DRIVER_ORDERS_SUCCESS"
export const GET_DRIVER_ORDERS_FAIL = "GET_DRIVER_ORDERS_FAIL"

export const GET_DISPATCH_HISTORY_LIST = "GET_DISPATCH_HISTORY_LIST"
export const GET_DISPATCH_HISTORY_LIST_SUCCESS = "GET_DISPATCH_HISTORY_LIST_SUCCESS"
export const GET_DISPATCH_HISTORY_LIST_FAIL = "GET_DISPATCH_HISTORY_LIST_FAIL"

export const CREATE_DISPATCH_HISTORY = "CREATE_DISPATCH_HISTORY"
export const CREATE_DISPATCH_HISTORY_SUCCESS = "CREATE_DISPATCH_HISTORY_SUCCESS"
export const CREATE_DISPATCH_HISTORY_FAIL = "CREATE_DISPATCH_HISTORY_FAIL"

export const GET_BATCH_INFO = "GET_BATCH_INFO"
export const GET_BATCH_INFO_SUCCESS = "GET_BATCH_INFO_SUCCESS"
export const GET_BATCH_INFO_FAIL = "GET_BATCH_INFO_FAIL"

export const RESET_ORDERS = "RESET_ORDERS"

export const UPDATE_DISPATCH_HISTORY = "UPDATE_DISPATCH_HISTORY"
export const UPDATE_DISPATCH_HISTORY_SUCCESS = "UPDATE_DISPATCH_HISTORY_SUCCESS"
export const UPDATE_DISPATCH_HISTORY_FAIL = "UPDATE_DISPATCH_HISTORY_FAIL"

export const UPDATE_ROUTE_PATTERN = "UPDATE_ROUTE_PATTERN "
export const UPDATE_ROUTE_PATTERN_SUCCESS = "UPDATE_ROUTE_PATTERN_SUCCESS"
export const UPDATE_ROUTE_PATTERN_FAIL = "UPDATE_ROUTE_PATTERN_FAIL"

export const DELETE_ACCOUNT_DOCUMENT = "DELETE_ACCOUNT_DOCUMENT"
export const DELETE_ACCOUNT_DOCUMENT_SUCCESS = "DELETE_ACCOUNT_DOCUMENT_SUCCESS"
export const DELETE_ACCOUNT_DOCUMENT_FAIL = "DELETE_ACCOUNT_DOCUMENT_FAIL"

export const GET_ORDERS_STATUS_WEIGHT = "GET_ORDERS_STATUS_WEIGHT"
export const GET_ORDERS_STATUS_WEIGHT_SUCCESS = "GET_ORDERS_STATUS_WEIGHT_SUCCESS"
export const GET_ORDERS_STATUS_WEIGHT_FAIL = "GET_ORDERS_STATUS_WEIGHT_FAIL"

export const HANDLE_FILTER_CHANGE = "HANDLE_FILTER_CHANGE"

export const GET_ORDERS_BY_SHIPPING_STATUS = "GET_ORDERS_BY_SHIPPING_STATUS"
export const GET_ORDERS_BY_SHIPPING_STATUS_SUCCESS = "GET_ORDERS_BY_SHIPPING_STATUS_SUCCESS"
export const GET_ORDERS_BY_SHIPPING_STATUS_FAIL = "GET_ORDERS_BY_SHIPPING_STATUS_FAIL"

export const GET_ZIP_CODE_BOUNDARY = "GET_ZIP_CODE_BOUNDARY"
export const GET_ZIP_CODE_BOUNDARY_SUCCESS = "GET_ZIP_CODE_BOUNDARY_SUCCESS"
export const GET_ZIP_CODE_BOUNDARY_FAIL = "GET_ZIP_CODE_BOUNDARY_FAIL"

//RM
export const POST_ROUTE_PREVIEW = "POST_ROUTE_PREVIEW"
export const POST_ROUTE_PREVIEW_SUCCESS = "POST_ROUTE_PREVIEW_SUCCESS"
export const POST_ROUTE_PREVIEW_FAIL = "POST_ROUTE_PREVIEW_FAIL"
export const RESET_ROUTE_PREVIEW = "RESET_ROUTE_PREVIEW"

export const POST_ROUTE_PREVIEW_HOPPER = "POST_ROUTE_PREVIEW_HOPPER"
export const POST_ROUTE_PREVIEW_HOPPER_SUCCESS = "POST_ROUTE_PREVIEW_HOPPER_SUCCESS"
export const POST_ROUTE_PREVIEW_HOPPER_FAIL = "POST_ROUTE_PREVIEW_HOPPER_FAIL"

export const POST_SAVE_ROUTE = "POST_SAVE_ROUTE"
export const POST_SAVE_ROUTE_SUCCESS = "POST_SAVE_ROUTE_SUCCESS"
export const POST_SAVE_ROUTE_FAIL = "POST_SAVE_ROUTE_FAIL"

export const GET_IS_ROUTES_SET = "GET_IS_ROUTES_SET"
export const GET_IS_ROUTES_SET_SUCCESS = "GET_IS_ROUTES_SET_SUCCESS"
export const GET_IS_ROUTES_SET_FAIL = "GET_IS_ROUTES_SET_FAIL"

export const GET_ROUTE_PLANNED_COUNT = "GET_ROUTE_PLANNED_COUNT"
export const GET_ROUTE_PLANNED_COUNT_SUCCESS = "GET_ROUTE_PLANNED_COUNT_SUCCESS"
export const GET_ROUTE_PLANNED_COUNT_FAIL = "GET_ROUTE_PLANNED_COUNT_FAIL"

export const GET_ROUTE_PLANNERS = "GET_ROUTE_PLANNERS"
export const GET_ROUTE_PLANNERS_SUCCESS = "GET_ROUTE_PLANNERS_SUCCESS"
export const GET_ROUTE_PLANNERS_FAIL = "GET_ROUTE_PLANNERS_FAIL"

export const HANDLE_CURRENT_DRIVER_ID = "HANDLE_CURRENT_DRIVER_ID"

export const HANDLE_CURRENT_ROUTE_TYPE = "HANDLE_CURRENT_ROUTE_TYPE"

export const LOCATION_VERIFY = "LOCATION_VERIFY"
export const LOCATION_VERIFY_SUCCESS = "LOCATION_VERIFY_SUCCESS"
export const LOCATION_VERIFY_FAIL = "LOCATION_VERIFY_FAIL"

// SSM
export const GET_ALL_CLEARING_EVENTS = "GET_ALL_CLEARING_EVENTS"
export const GET_ALL_CLEARING_EVENTS_SUCCESS = "GET_ALL_CLEARING_EVENTS_SUCCESS"
export const GET_ALL_CLEARING_EVENTS_FAIL = "GET_ALL_CLEARING_EVENTS_FAIL"

export const GET_ALL_CLEARING_ITEMS = "GET_ALL_CLEARING_ITEMS"
export const GET_ALL_CLEARING_ITEMS_SUCCESS = "GET_ALL_CLEARING_ITEMS_SUCCESS"
export const GET_ALL_CLEARING_ITEMS_FAIL = "GET_ALL_CLEARING_ITEMS_FAIL"

export const CHANGE_BATCH_SEND_NO = "CHANGE_BATCH_SEND_NO"

export const TEXT_FUNCTION_OPEN = "TEXT_FUNCTION_OPEN"

export const VERIFY_PARCEL_EXISTENCE = "VERIFY_PARCEL_EXISTENCE"
export const VERIFY_PARCEL_EXISTENCE_SUCCESS = "VERIFY_PARCEL_EXISTENCE_SUCCESS"
export const VERIFY_PARCEL_EXISTENCE_FAIL = "VERIFY_PARCEL_EXISTENCE_FAIL"

export const CREATE_CLEARING_EVENT = "CREATE_CLEARING_EVENT"
export const CREATE_CLEARING_EVENT_SUCCESS = "CREATE_CLEARING_EVENT"
export const CREATE_CLEARING_EVENT_FAIL = "CREATE_CLEARING_EVENT"

export const DELETE_CLEARING_EVENT = "CREATE_CLEARING_EVENT"
export const DELETE_CLEARING_EVENT_SUCCESS = "CREATE_CLEARING_EVENT"
export const DELETE_CLEARING_EVENT_FAIL = "CREATE_CLEARING_EVENT"

export const RETRIED_PLUS_ONE = "RETRIED_PLUS_ONE"
export const RETRIED_PLUS_ONE_SUCCESS = "RETRIED_PLUS_ONE_SUCCESS"
export const RETRIED_PLUS_ONE_FAIL = "RETRIED_PLUS_ONE_FAIL"

export const BATCH_SEND_EXPIRED_ALERT = "BATCH_SEND_EXPIRED_ALERT"
export const BATCH_SEND_EXPIRED_ALERT_SUCCESS = "BATCH_SEND_EXPIRED_ALERT_SUCCESS"
export const BATCH_SEND_EXPIRED_ALERT_FAIL = "BATCH_SEND_EXPIRED_ALERT_FAIL"

export const GET_SMS_ALERT_HISTORY = "GET_SMS_ALERT_HISTORY"
export const GET_SMS_ALERT_HISTORY_SUCCESS = "GET_SMS_ALERT_HISTORY_SUCCESS"
export const GET_SMS_ALERT_HISTORY_FAIL = "GET_SMS_ALERT_HISTORY_FAIL"

export const INIT_SMS_STATUS_DATA = "INIT_SMS_STATUS_DATA"
export const INIT_SMS_STATUS_DATA_SUCCESS = "INIT_SMS_STATUS_DATA_SUCCESS"
export const INIT_SMS_STATUS_DATA_FAIL = "INIT_SMS_STATUS_DATA_FAIL"

export const TEST_BATCH_SEND_EXPIRED_ALERT = "TEST_BATCH_SEND_EXPIRED_ALERT"
export const TEST_BATCH_SEND_EXPIRED_ALERT_SUCCESS = "TEST_BATCH_SEND_EXPIRED_ALERT_SUCCESS"
export const TEST_BATCH_SEND_EXPIRED_ALERT_FAIL = "TEST_BATCH_SEND_EXPIRED_ALERT_FAIL"

export const ABANDON_EXPIRED_PARCEL = "ABANDON_EXPIRED_PARCEL"
export const ABANDON_EXPIRED_PARCEL_SUCCESS = "ABANDON_EXPIRED_PARCEL_SUCCESS"
export const ABANDON_EXPIRED_PARCEL_FAIL = "ABANDON_EXPIRED_PARCEL_FAIL"

// HD
export const OAUTH_TOKEN = "OAUTH_TOKEN"
export const OAUTH_TOKEN_SUCCESS = "OAUTH_TOKEN_SUCCESS"
export const OAUTH_TOKEN_FAIL = "OAUTH_TOKEN_FAIL"

export const SEARCH_UNKNOWN_PACKAGE_DATA = "SEARCH_UNKNOWN_PACKAGE_DATA"
export const SEARCH_UNKNOWN_PACKAGE_DATA_SUCCESS = "SEARCH_UNKNOWN_PACKAGE_DATA_SUCCESS"
export const SEARCH_UNKNOWN_PACKAGE_DATA_FAIL = "SEARCH_UNKNOWN_PACKAGE_DATA_FAIL"

export const RESTORE_TO_STATE = "RESTORE_TO_STATE"
export const RESTORE_TO_STATE_SUCCESS = "RESTORE_TO_STATE_SUCCESS"
export const RESTORE_TO_STATE_FAIL = "RESTORE_TO_STATE_FAIL"

export const INSERT_OPERATION_LOG = "INSERT_OPERATION_LOG"
export const INSERT_OPERATION_LOG_SUCCESS = "INSERT_OPERATION_LOG_SUCCESS"
export const INSERT_OPERATION_LOG_FAIL = "INSERT_OPERATION_LOG_FAIL"

// QT
export const GET_LETIAN_STAFF_QT = "GET_LETIAN_STAFF_QT"
export const GET_LETIAN_STAFF_QT_SUCCESS = "GET_LETIAN_STAFF_QT_SUCCESS"
export const GET_LETIAN_STAFF_QT_FAIL = "GET_LETIAN_STAFF_QT_FAIL"

export const QUICK_TRANSFER_ORDERS_QT = "QUICK_TRANSFER_ORDERS_QT"
export const QUICK_TRANSFER_ORDERS_QT_SUCCESS = "QUICK_TRANSFER_ORDERS_QT_SUCCESS"
export const QUICK_TRANSFER_ORDERS_QT_FAIL = "QUICK_TRANSFER_ORDERS_QT_FAIL"

export const GET_LETIAN_STAFF_QT_TEMP = 'GET_LETIAN_STAFF_QT_TEMP'
export const GET_LETIAN_STAFF_QT_TEMP_SUCCESS = 'GET_LETIAN_STAFF_QT_TEMP'
export const GET_LETIAN_STAFF_QT_TEMP_FAIL = 'GET_LETIAN_STAFF_QT_TEMP'

export const TRANSFER_PACKAGES_IN_RANGE_QT = 'TRANSFER_PACKAGES_IN_RANGE_QT'
export const TRANSFER_PACKAGES_IN_RANGE_QT_SUCCESS = 'TRANSFER_PACKAGES_IN_RANGE_QT_SUCCESS'
export const TRANSFER_PACKAGES_IN_RANGE_QT_FAIL = 'TRANSFER_PACKAGES_IN_RANGE_QT_FAIL'

export const TRANSFER_SUB_BATCH = 'TRANSFER_SUB_BATCH'
export const TRANSFER_SUB_BATCH_SUCCESS = 'TRANSFER_SUB_BATCH_SUCCESS'
export const TRANSFER_SUB_BATCH_FAIL = 'TRANSFER_SUB_BATCH_FAIL'
export const REVERT_ORDER_PATH_STATE = 'REVERT_ORDER_PATH_STATE'
export const REVERT_ORDER_PATH_STATE_SUCCESS = 'REVERT_ORDER_PATH_STATE_SUCCESS'
export const REVERT_ORDER_PATH_STATE_FAIL = 'REVERT_ORDER_PATH_STATE_FAIL'

export const UPDADE_ORDER_POD = "UPDADE_ORDER_POD"
export const UPDADE_ORDER_POD_SUCCESS = "UPDADE_ORDER_POD_SUCCESS"
export const UPDADE_ORDER_POD_FAIL = "UPDADE_ORDER_POD_FAIL"

export const DELETE_ORDER_POD = "DELETE_ORDER_POD"
export const DELETE_ORDER_POD_SUCCESS = "DELETE_ORDER_POD_SUCCESS"
export const DELETE_ORDER_POD_FAIL = "DELETE_ORDER_POD_FAIL"

export const GET_ORDER_POD = "GET_ORDER_POD"
export const GET_ORDER_POD_SUCCESS = "GET_ORDER_POD_SUCCESS"
export const GET_ORDER_POD_FAIL = "GET_ORDER_POD_FAIL"

// SR
export const RETURN_HISTORY = "RETURN_HISTORY"
export const RETURN_HISTORY_SUCCESS = "RETURN_HISTORY_SUCCESS"
export const RETURN_HISTORY_FAIL = "RETURN_HISTORY_FAIL"

export const GET_DRIVER_APP_RETURN_LIST = "GET_DRIVER_APP_RETURN_LIST"
export const GET_DRIVER_APP_RETURN_LIST_SUCCESS = "GET_DRIVER_APP_RETURN_LIST_SUCCESS"
export const GET_DRIVER_APP_RETURN_LIST_FAIL = "GET_DRIVER_APP_RETURN_LIST_FAIL"

export const SELF_RETURN_MANUAL = "SELF_RETURN_MANUAL"
export const SELF_RETURN_MANUAL_SUCCESS = "SELF_RETURN_MANUAL_SUCCESS"
export const SELF_RETURN_MANUAL_FAIL = "SELF_RETURN_MANUAL_FAIL"

export const GET_NEW_STORAGE_INFO = "GET_NEW_STORAGE_INFO"
export const GET_NEW_STORAGE_INFO_SUCCESS = "GET_NEW_STORAGE_INFO_SUCCESS"
export const GET_NEW_STORAGE_INFO_FAIL = "GET_NEW_STORAGE_INFO_FAIL"

// SA
export const GET_SORTING_HISTORY = "GET_SORTING_HISTORY"
export const GET_SORTING_HISTORY_SUCCESS = "GET_SORTING_HISTORY_SUCCESS"
export const GET_SORTING_HISTORY_FAIL = "GET_SORTING_HISTORY_FAIL"

export const GET_SORTING_HISTORY_LIST = "GET_SORTING_HISTORY_LIST"
export const GET_SORTING_HISTORY_LIST_SUCCESS = "GET_SORTING_HISTORY_LIST_SUCCESS"
export const GET_SORTING_HISTORY_LIST_FAIL = "GET_SORTING_HISTORY_LIST_FAIL"

export const SAVE_SORTING_HISTORY = "SAVE_SORTING_HISTORY"
export const SAVE_SORTING_HISTORY_SUCCESS = "SAVE_SORTING_HISTORY_SUCCESS"
export const SAVE_SORTING_HISTORY_FAIL = "SAVE_SORTING_HISTORY_FAIL"

export const APPLY_CONFIGURATION = "APPLY_CONFIGURATION"
export const APPLY_CONFIGURATION_SUCCESS = "APPLY_CONFIGURATION_SUCCESS"
export const APPLY_CONFIGURATION_FAIL = "APPLY_CONFIGURATION_FAIL"

export const GET_WAREHOUSE_TOTAL_SLOTS = "GET_WAREHOUSE_TOTAL_SLOTS"
export const GET_WAREHOUSE_TOTAL_SLOTS_SUCCESS = "GET_WAREHOUSE_TOTAL_SLOTS_SUCCESS"
export const GET_WAREHOUSE_TOTAL_SLOTS_FAIL = "GET_WAREHOUSE_TOTAL_SLOTS_FAIL"

export const GET_BATCH_ALL = "GET_BATCH_ALL"
export const GET_BATCH_ALL_SUCCESS = "GET_BATCH_ALL_SUCCESS"
export const GET_BATCH_ALL_FAIL = "GET_BATCH_ALL_FAIL"

export const GET_BATCH_ORDER_ALL = "GET_BATCH_ORDER_ALL"
export const GET_BATCH_ORDER_ALL_SUCCESS = "GET_BATCH_ORDER_ALL_SUCCESS"
export const GET_BATCH_ORDER_ALL_FAIL = "GET_BATCH_ORDER_ALL_FAIL"

export const GET_BATCH_INFO_ALL = "GET_BATCH_INFO_ALL"
export const GET_BATCH_INFO_ALL_SUCCESS = "GET_BATCH_INFO_ALL_SUCCESS"
export const GET_BATCH_INFO_ALL_FAIL = "GET_BATCH_INFO_ALL_FAIL"

export const GET_DRIVER_ORDER_COUNT_ALL = "GET_DRIVER_ORDER_COUNT_ALL"
export const GET_DRIVER_ORDER_COUNT_ALL_SUCCESS = "GET_DRIVER_ORDER_COUNT_ALL_SUCCESS"
export const GET_DRIVER_ORDER_COUNT_ALL_FAIL = "GET_DRIVER_ORDER_COUNT_ALL_FAIL"

export const GET_DISTRICT_ALL = "GET_DISTRICT_ALL"
export const GET_DISTRICT_ALL_SUCCESS = "GET_DISTRICT_ALL_SUCCESS"
export const GET_DISTRICT_ALL_FAIL = "GET_DISTRICT_ALL_FAIL"

export const GET_STAFF_LIST_ALL = "GET_STAFF_LIST_ALL"
export const GET_STAFF_LIST_ALL_SUCCESS = "GET_STAFF_LIST_ALL_SUCCESS"
export const GET_STAFF_LIST_ALL_FAIL = "GET_STAFF_LIST_ALL_FAIL"

export const GET_BLIND_SCAN_BATCH = "GET_BLIND_SCAN_BATCH"
export const GET_BLIND_SCAN_BATCH_SUCCESS = "GET_BLIND_SCAN_BATCH_SUCCESS"
export const GET_BLIND_SCAN_BATCH_FAIL = "GET_BLIND_SCAN_BATCH_FAIL"

export const SET_BLIND_BATCH = "SET_BLIND_BATCH"
export const SET_BLIND_BATCH_SUCCESS = "SET_BLIND_BATCH_SUCCESS"
export const SET_BLIND_BATCH_FAIL = "SET_BLIND_BATCH_FAIL"

export const SET_SCAN_MODE = "SET_SCAN_MODE"
export const SET_SCAN_MODE_SUCCESS = "SET_SCAN_MODE_SUCCESS"
export const SET_SCAN_MODE_FAIL = "SET_SCAN_MODE_FAIL"

export const GET_MACHINE_CONFIG = "GET_MACHINE_CONFIG"
export const GET_MACHINE_CONFIG_SUCCESS = "GET_MACHINE_CONFIG_SUCCESS"
export const GET_MACHINE_CONFIG_FAIL = "GET_MACHINE_CONFIG_FAIL"

export const SET_SCAN_BATCH_LIST = "SET_SCAN_BATCH_LIST"
export const SET_SCAN_BATCH_LIST_SUCCESS = "SET_SCAN_BATCH_LIST_SUCCESS"
export const SET_SCAN_BATCH_LIST_FAIL = "SET_SCAN_BATCH_LIST_FAIL"

export const CREATE_ZONE_SLOT_MAPPING = "CREATE_ZONE_SLOT_MAPPING"
export const CREATE_ZONE_SLOT_MAPPING_SUCCESS = "CREATE_ZONE_SLOT_MAPPING_SUCCESS"
export const CREATE_ZONE_SLOT_MAPPING_FAIL = "CREATE_ZONE_SLOT_MAPPING_FAIL"

export const GET_ZONE_SLOT_MAPPING = "GET_ZONE_SLOT_MAPPING"
export const GET_ZONE_SLOT_MAPPING_SUCCESS = "GET_ZONE_SLOT_MAPPING_SUCCESS"
export const GET_ZONE_SLOT_MAPPING_FAIL = "GET_ZONE_SLOT_MAPPING_FAIL"

export const EDIT_ZONE_SLOT_MAPPING = "EDIT_ZONE_SLOT_MAPPING"
export const EDIT_ZONE_SLOT_MAPPING_SUCCESS = "EDIT_ZONE_SLOT_MAPPING_SUCCESS"
export const EDIT_ZONE_SLOT_MAPPING_FAIL = "EDIT_ZONE_SLOT_MAPPING_FAIL"

export const GET_PATTERN_ID_TYPE = "GET_PATTERN_ID_TYPE"
export const GET_PATTERN_ID_TYPE_SUCCESS = "GET_PATTERN_ID_TYPE_SUCCESS"
export const GET_PATTERN_ID_TYPE_FAIL = "GET_PATTERN_ID_TYPE_FAIL"

export const GET_SORT_MANAGEMENT_LIST = "GET_SORT_MANAGEMENT_LIST"
export const GET_SORT_MANAGEMENT_LIST_SUCCESS = "GET_SORT_MANAGEMENT_LIST_SUCCESS"
export const GET_SORT_MANAGEMENT_LIST_FAIL = "GET_SORT_MANAGEMENT_LIST_FAIL"

export const EDIT_SORTING_MANAGEMENT = "EDIT_SORTING_MANAGEMENT"
export const EDIT_SORTING_MANAGEMENT_SUCCESS = "EDIT_SORTING_MANAGEMENT_SUCCESS"
export const EDIT_SORTING_MANAGEMENT_FAIL = "EDIT_SORTING_MANAGEMENT_FAIL"

export const GET_ALL_MACHINE_CODES = "GET_ALL_MACHINE_CODES"
export const GET_ALL_MACHINE_CODES_SUCCESS = "GET_ALL_MACHINE_CODES_SUCCESS"
export const GET_ALL_MACHINE_CODES_FAIL = "GET_ALL_MACHINE_CODES_FAIL"

export const DELETE_ZONE_SLOT = "DELETE_ZONE_SLOT"
export const DELETE_ZONE_SLOT_SUCCESS = "DELETE_ZONE_SLOT_SUCCESS"
export const DELETE_ZONE_SLOT_FAIL = "DELETE_ZONE_SLOT_FAIL"

// TOSB
export const SPLIT_ORDERS = "SPLIT_ORDERS"
export const SPLIT_ORDERS_SUCCESS = "SPLIT_ORDERS_SUCCESS"
export const SPLIT_ORDERS_FAIL = "SPLIT_ORDERS_FAIL"

export const CREATE_SUB_BATCH_NEW = "CREATE_SUB_BATCH_NEW"
export const CREATE_SUB_BATCH_NEW_SUCCESS = "CREATE_SUB_BATCH_NEW_SUCCESS"
export const CREATE_SUB_BATCH_NEW_FAIL = "CREATE_SUB_BATCH_NEW_FAIL"

export const MARK_AS_REMOTE_ORDERS = "MARK_AS_REMOTE_ORDERS"
export const MARK_AS_REMOTE_ORDERS_SUCCESS = "MARK_AS_REMOTE_ORDERS_SUCCESS"
export const MARK_AS_REMOTE_ORDERS_FAIL = "MARK_AS_REMOTE_ORDERS_FAIL"

export const FILTER_REMOTE_ORDERS = "FILTER_REMOTE_ORDERS"
export const FILTER_REMOTE_ORDERS_SUCCESS = "FILTER_REMOTE_ORDERS_SUCCESS"
export const FILTER_REMOTE_ORDERS_FAIL = "FILTER_REMOTE_ORDERS_FAIL"

export const GET_BLIND_SCAN_BATCH_LIST = "GET_BLIND_SCAN_BATCH_LIST"
export const GET_BLIND_SCAN_BATCH_LIST_SUCCESS = "GET_BLIND_SCAN_BATCH_LIST_SUCCESS"
export const GET_BLIND_SCAN_BATCH_LIST_FAIL = "GET_BLIND_SCAN_BATCH_LIST_FAIL"

export const SET_BLIND_SCAN_BATCH_EFFECT = "SET_BLIND_SCAN_BATCH_EFFECT"
export const SET_BLIND_SCAN_BATCH_EFFECT_SUCCESS = "SET_BLIND_SCAN_BATCH_EFFECT_SUCCESS"
export const SET_BLIND_SCAN_BATCH_EFFECT_FAIL = "SET_BLIND_SCAN_BATCH_EFFECT_FAIL"

// HPM
export const ADD_HOLDING_PACKAGE_BY_BAGS = "ADD_HOLDING_PACKAGE_BY_BAGS"
export const ADD_HOLDING_PACKAGE_BY_BAGS_SUCCESS = "ADD_HOLDING_PACKAGE_BY_BAGS_SUCCESS"
export const ADD_HOLDING_PACKAGE_BY_BAGS_FAIL = "ADD_HOLDING_PACKAGE_BY_BAGS_FAIL"

export const HANDLE_BLOCK_BATCH = "HANDLE_BLOCK_BATCH"

export const ADD_HOLDING_PACKAGES = "ADD_HOLDING_PACKAGES"
export const ADD_HOLDING_PACKAGES_SUCCESS = "ADD_HOLDING_PACKAGES_SUCCESS"
export const ADD_HOLDING_PACKAGES_FAIL = "ADD_HOLDING_PACKAGES_FAIL"

export const GET_HOLDING_REPORT = "GET_HOLDING_REPORT"
export const GET_HOLDING_REPORT_SUCCESS = "GET_HOLDING_REPORT_SUCCESS"
export const GET_HOLDING_REPORT_FAIL = "GET_HOLDING_REPORT_FAIL"

export const GET_HOLDING_KEY = "GET_HOLDING_KEY"
export const GET_HOLDING_KEY_SUCCESS = "GET_HOLDING_KEY_SUCCESS"
export const GET_HOLDING_KEY_FAIL = "GET_HOLDING_KEY_FAIL"

export const CANCEL_BATCH = "CANCEL_BATCH"
export const CANCEL_BATCH_SUCCESS = "CANCEL_BATCH_SUCCESS"
export const CANCEL_BATCH_FAIL = "CANCEL_BATCH_FAIL"

export const CANCEL_TNO = "CANCEL_TNO"
export const CANCEL_TNO_SUCCESS = "CANCEL_TNO_SUCCESS"
export const CANCEL_TNO_FAIL = "CANCEL_TNO_FAIL"

// DD
export const GET_LETIAN_STAFF = "GET_LETIAN_STAFF"
export const GET_LETIAN_STAFF_SUCCESS = "GET_LETIAN_STAFF_SUCCESS"
export const GET_LETIAN_STAFF_FAIL = "GET_LETIAN_STAFF_FAIL"

export const GET_DRIVER_DISPATCH_BETWEEN = "GET_DRIVER_DISPATCH_BETWEEN"
export const GET_DRIVER_DISPATCH_BETWEEN_SUCCESS = "GET_DRIVER_DISPATCH_BETWEEN_SUCCESS"
export const GET_DRIVER_DISPATCH_BETWEEN_FAIL = "GET_DRIVER_DISPATCH_BETWEEN_FAIL"

export const GET_DRIVER_DISPATCH_BY_ID = "GET_DRIVER_DISPATCH_BY_ID"
export const GET_DRIVER_DISPATCH_BY_ID_SUCCESS = "GET_DRIVER_DISPATCH_BY_ID_SUCCESS"
export const GET_DRIVER_DISPATCH_BY_ID_FAIL = "GET_DRIVER_DISPATCH_BY_ID_FAIL"

export const QUICK_TRANSFER_ORDERS = "QUICK_TRANSFER_ORDERS"
export const QUICK_TRANSFER_ORDERS_SUCCESS = "QUICK_TRANSFER_ORDERS_SUCCESS"
export const QUICK_TRANSFER_ORDERS_FAIL = "QUICK_TRANSFER_ORDERS_FAIL"

export const GET_DRIVER_DROPOFF_HISTORY = "GET_DRIVER_DROPOFF_HISTORY"
export const GET_DRIVER_DROPOFF_HISTORY_SUCCESS = "GET_DRIVER_DROPOFF_HISTORY_SUCCESS"
export const GET_DRIVER_DROPOFF_HISTORY_FAIL = "GET_DRIVER_DROPOFF_HISTORY_FAIL"

export const GET_DISPATCH_LIST_HISTORY = "GET_DISPATCH_LIST_HISTORY"
export const GET_DISPATCH_LIST_HISTORY_SUCCESS = "GET_DISPATCH_LIST_HISTORY_SUCCESS"
export const GET_DISPATCH_LIST_HISTORY_FAIL = "GET_DISPATCH_LIST_HISTORY_FAIL"

export const GET_SCAN_BATCH_REPORTS = "GET_SCAN_BATCH_REPORTS"
export const GET_SCAN_BATCH_REPORTS_SUCCESS = "GET_SCAN_BATCH_REPORTS_SUCCESS"
export const GET_SCAN_BATCH_REPORTS_FAIL = "GET_SCAN_BATCH_REPORTS_FAIL"

export const SET_SCAN_BATCH_STATUS = "SET_SCAN_BATCH_STATUS"
export const SET_SCAN_BATCH_STATUS_SUCCESS = "SET_SCAN_BATCH_STATUS_SUCCESS"
export const SET_SCAN_BATCH_STATUS_FAIL = "SET_SCAN_BATCH_STATUS_FAIL"

export const GET_ORDERS_BY_DRIVER_CRITERIA = "GET_ORDERS_BY_DRIVER_CRITERIA"
export const GET_ORDERS_BY_DRIVER_CRITERIA_SUCCESS = "GET_ORDERS_BY_DRIVER_CRITERIA_SUCCESS"
export const GET_ORDERS_BY_DRIVER_CRITERIA_FAIL = "GET_ORDERS_BY_DRIVER_CRITERIA_FAIL"

export const UPDATE_DISPATCH_SUMMARY = "UPDATE_DISPATCH_SUMMARY"
export const UPDATE_DISPATCH_SUMMARY_SUCCESS = "UPDATE_DISPATCH_SUMMARY_SUCCESS"
export const UPDATE_DISPATCH_SUMMARY_FAIL = "UPDATE_DISPATCH_SUMMARY_FAIL"

export const HANDLE_DRIVER_ID_DISPATCH = "HANDLE_DRIVER_ID_DISPATCH"

export const UPDATE_SCAN_STATUS = "UPDATE_SCAN_STATUS"
export const UPDATE_SCAN_STATUS_SUCCESS = "UPDATE_SCAN_STATUS_SUCCESS"
export const UPDATE_SCAN_STATUS_FAIL = "UPDATE_SCAN_STATUS_FAIL"

export const HANDLE_RETURN_SCAN = "HANDLE_RETURN_SCAN"
export const HANDLE_RETURN_SCAN_SUCCESS = "HANDLE_RETURN_SCAN_SUCCESS"
export const HANDLE_RETURN_SCAN_FAIL = "HANDLE_RETURN_SCAN_FAIL"

// scanReport
export const GET_BLIND_SCAN_PROGRESS = "GET_BLIND_SCAN_PROGRESS"
export const GET_BLIND_SCAN_PROGRESS_SUCCESS = "GET_BLIND_SCAN_PROGRESS_SUCCESS"
export const GET_BLIND_SCAN_PROGRESS_FAIL = "GET_BLIND_SCAN_PROGRESS_FAIL"

// complaints
export const GET_ALL_COMPLAINTS = "GET_ALL_COMPLAINTS"
export const GET_ALL_COMPLAINTS_SUCCESS = "GET_ALL_COMPLAINTS_SUCCESS"
export const GET_ALL_COMPLAINTS_FAIL = "GET_ALL_COMPLAINTS_FAIL"

// EDRR
export const ETA_DELIVERY_RATE_REPORT = "ETA_DELIVERY_RATE_REPORT"
export const ETA_DELIVERY_RATE_REPORT_SUCCESS = "ETA_DELIVERY_RATE_REPORT_SUCCESS"
export const ETA_DELIVERY_RATE_REPORT_FAIL = "ETA_DELIVERY_RATE_REPORT_FAIL"

export const GET_ETA_DELIVERY_RATE_REPORT = "ETA_DELIVERY_RATE_REPORT"
export const GET_ETA_DELIVERY_RATE_REPORT_SUCCESS = "ETA_DELIVERY_RATE_REPORT_SUCCESS"
export const GET_ETA_DELIVERY_RATE_REPORT_FAIL = "ETA_DELIVERY_RATE_REPORT_FAIL"

// Reschedule Delivery
export const CREATE_SECOND_DELIVERY_BATCH = "CREATE_SECOND_DELIVERY_BATCH"
export const CREATE_SECOND_DELIVERY_BATCH_SUCCESS = "CREATE_SECOND_DELIVERY_BATCH_SUCCESS"
export const CREATE_SECOND_DELIVERY_BATCH_FAIL = "CREATE_SECOND_DELIVERY_BATCH_FAIL"

export const GET_SECOND_DELIVERY_ORDERS = "export const GET_SECOND_DELIVERY_ORDERS"
export const GET_SECOND_DELIVERY_ORDERS_SUCCESS = "export const GET_SECOND_DELIVERY_ORDERS_SUCCESS"
export const GET_SECOND_DELIVERY_ORDERS_FAIL = "export const GET_SECOND_DELIVERY_ORDERS_FAIL"

// Batch Management
export const UPDATE_BATCH_COMMENTS = "UPDATE_BATCH_COMMENTS"
export const UPDATE_BATCH_COMMENTS_SUCCESS = "UPDATE_BATCH_COMMENTS_SUCCESS"
export const UPDATE_BATCH_COMMENTS_FAIL = "UPDATE_BATCH_COMMENTS_FAIL"

// UT
export const GET_BAG_ORDER_BY_BAG_NO = "GET_BAG_ORDER_BY_BAG_NO"
export const GET_BAG_ORDER_BY_BAG_NO_SUCCESS = "GET_BAG_ORDER_BY_BAG_NO_SUCCESS"
export const GET_BAG_ORDER_BY_BAG_NO_FAIL = "GET_BAG_ORDER_BY_BAG_NO_FAIL"

export const UPDATE_ORDERS_BY_BAG_NO = "UPDATE_ORDERS_BY_BAG_NO"
export const UPDATE_ORDERS_BY_BAG_NO_SUCCESS = "UPDATE_ORDERS_BY_BAG_NO_SUCCESS"
export const UPDATE_ORDERS_BY_BAG_NO_FAIL = "UPDATE_ORDERS_BY_BAG_NO_FAIL"

export const SAVE_BOX_SCAN_HISTORY = "SAVE_BOX_SCAN_HISTORY"
export const SAVE_BOX_SCAN_HISTORY_SUCCESS = "SAVE_BOX_SCAN_HISTORY_SUCCESS"
export const SAVE_BOX_SCAN_HISTORY_FAIL = "SAVE_BOX_SCAN_HISTORY_FAIL"

export const GET_BOX_SCAN_HISTORIES = "GET_BOX_SCAN_HISTORIES"
export const GET_BOX_SCAN_HISTORIES_SUCCESS = "GET_BOX_SCAN_HISTORIES_SUCCESS"
export const GET_BOX_SCAN_HISTORIES_FAIL = "GET_BOX_SCAN_HISTORIES_FAIL"

export const GET_BOX_UPDATE_SUMMARY = "GET_BOX_UPDATE_SUMMARY"
export const GET_BOX_UPDATE_SUMMARY_SUCCESS = "GET_BOX_UPDATE_SUMMARY_SUCCESS"
export const GET_BOX_UPDATE_SUMMARY_FAIL = "GET_BOX_UPDATE_SUMMARY_FAIL"

export const FETCH_ORDER_INFO_BY_TRACKING_NUMBER = "FETCH_ORDER_INFO_BY_TRACKING_NUMBER"
export const FETCH_ORDER_INFO_BY_TRACKING_NUMBER_SUCCESS = "FETCH_ORDER_INFO_BY_TRACKING_NUMBER_SUCCESS"
export const FETCH_ORDER_INFO_BY_TRACKING_NUMBER_FAIL = "FETCH_ORDER_INFO_BY_TRACKING_NUMBER_FAIL"

export const SCAN_TO_REMOVE = "SCAN_TO_REMOVE"
export const SCAN_TO_REMOVE_SUCCESS = "SCAN_TO_REMOVE_SUCCESS"
export const SCAN_TO_REMOVE_FAIL = "SCAN_TO_REMOVE_FAIL"

export const SCAN_WRONG_AREA = "SCAN_WRONG_AREA"
export const SCAN_WRONG_AREA_SUCCESS = "SCAN_WRONG_AREA_SUCCESS"
export const SCAN_WRONG_AREA_FAIL = "SCAN_WRONG_AREA_FAIL"

export const FETCH_ORDER_INFO_BY_UPS_ORDER_NUMBER = "FETCH_ORDER_INFO_BY_UPS_ORDER_NUMBER"
export const FETCH_ORDER_INFO_BY_UPS_ORDER_NUMBER_SUCCESS = "FETCH_ORDER_INFO_BY_UPS_ORDER_NUMBER_SUCCESS"
export const FETCH_ORDER_INFO_BY_UPS_ORDER_NUMBER_FAIL = "FETCH_ORDER_INFO_BY_UPS_ORDER_NUMBER_FAIL"

export const SCAN_REJECT = "SCAN_REJECT"
export const SCAN_REJECT_SUCCESS = "SCAN_REJECT_SUCCESS"
export const SCAN_REJECT_FAIL = "SCAN_REJECT_FAIL"

export const EDIT_CARGO_TRACKING = "EDIT_CARGO_TRACKING"
export const EDIT_CARGO_TRACKING_SUCCESS = "EDIT_CARGO_TRACKING_SUCCESS"
export const EDIT_CARGO_TRACKING_FAIL = "EDIT_CARGO_TRACKING_FAIL"

export const BATCH_CREATE_SECOND_DELIVERY = "BATCH_CREATE_SECOND_DELIVERY"
export const BATCH_CREATE_SECOND_DELIVERY_SUCCESS = "BATCH_CREATE_SECOND_DELIVERY_SUCCESS"
export const BATCH_CREATE_SECOND_DELIVERY_FAIL = "BATCH_CREATE_SECOND_DELIVERY_FAIL"

export const VALIDATE_BAG_NO = "VALIDATE_BAG_NO"
export const VALIDATE_BAG_NO_SUCCESS = "VALIDATE_BAG_NO_SUCCESS"
export const VALIDATE_BAG_NO_FAIL = "VALIDATE_BAG_NO_FAIL"

export const UPDATE_ORDERS_BY_TNOS = "UPDATE_ORDERS_BY_TNOS"
export const UPDATE_ORDERS_BY_TNOS_SUCCESS = "UPDATE_ORDERS_BY_TNOS_SUCCESS"
export const UPDATE_ORDERS_BY_TNOS_FAIL = "UPDATE_ORDERS_BY_TNOS_FAIL"

export const UPDATE_TRACKING_EXCEPTION_BY_TNO = "UPDATE_TRACKING_EXCEPTION_BY_TNO"
export const UPDATE_TRACKING_EXCEPTION_BY_TNO_SUCCESS = "UPDATE_TRACKING_EXCEPTION_BY_TNO_SUCCESS"
export const UPDATE_TRACKING_EXCEPTION_BY_TNO_FAIL = "UPDATE_TRACKING_EXCEPTION_BY_TNO_FAIL"

export const BATCH_UPDATE_TO_GATEWAY_OUT = "BATCH_UPDATE_TO_GATEWAY_OUT"
export const BATCH_UPDATE_TO_GATEWAY_OUT_SUCCESS = "BATCH_UPDATE_TO_GATEWAY_OUT_SUCCESS"
export const BATCH_UPDATE_TO_GATEWAY_OUT_FAIL = "BATCH_UPDATE_TO_GATEWAY_OUT_FAIL"

export const VIEW_UPDATE_ORDERS_BY_TNOS = "VIEW_UPDATE_ORDERS_BY_TNOS"
export const VIEW_UPDATE_ORDERS_BY_TNOS_SUCCESS = "VIEW_UPDATE_ORDERS_BY_TNOS_SUCCESS"
export const VIEW_UPDATE_ORDERS_BY_TNOS_FAIL = "VIEW_UPDATE_ORDERS_BY_TNOS_FAIL"

// Upload Excel
export const UPLOAD_EXCEL = "UPLOAD_EXCEL"
export const UPLOAD_EXCEL_SUCCESS = "UPLOAD_EXCEL_SUCCESS"
export const UPLOAD_EXCEL_FAIL = "UPLOAD_EXCEL_FAIL"

// Last State Statistics
export const GET_LAST_STATE_STATISTICS = "GET_LAST_STATE_STATISTICS"
export const GET_LAST_STATE_STATISTICS_SUCCESS = "GET_LAST_STATE_STATISTICS_SUCCESS"
export const GET_LAST_STATE_STATISTICS_FAIL = "GET_LAST_STATE_STATISTICS_FAIL"

export const GET_DELIVER_RETURN = "GET_DELIVER_RETURN"
export const GET_DELIVER_RETURN_SUCCESS = "GET_DELIVER_RETURN_SUCCESS"
export const GET_DELIVER_RETURN_FAIL = "GET_DELIVER_RETURN_FAIL"

export const GET_WRONG_ROUTE_ORDERS = "GET_WRONG_ROUTE_ORDERS"
export const GET_WRONG_ROUTE_ORDERS_SUCCESS = "GET_WRONG_ROUTE_ORDERS_SUCCESS"
export const GET_WRONG_ROUTE_ORDERS_FAIL = "GET_WRONG_ROUTE_ORDERS_FAIL"

// Local Delivery Management
export const GET_LOCAL_DELIVERY_ORDERS = "GET_LOCAL_DELIVERY_ORDERS"
export const GET_LOCAL_DELIVERY_ORDERS_SUCCESS = "GET_LOCAL_DELIVERY_ORDERS_SUCCESS"
export const GET_LOCAL_DELIVERY_ORDERS_FAIL = "GET_LOCAL_DELIVERY_ORDERS_FAIL"

// User Management
export const HANDLE_USER_MANAGEMENT_AUTH = "HANDLE_USER_MANAGEMENT_AUTH"

export const REGISTER_ACCOUNT = "REGISTER_ACCOUNT"
export const REGISTER_ACCOUNT_SUCCESS = "REGISTER_ACCOUNT_SUCCESS"
export const REGISTER_ACCOUNT_FAIL = "REGISTER_ACCOUNT_FAIL"

export const CHANGE_PASSWORD = "CHANGE_PASSWORD"
export const CHANGE_PASSWORD_SUCCESS = "CHANGE_PASSWORD_SUCCESS"
export const CHANGE_PASSWORD_FAIL = "CHANGE_PASSWORD_FAIL"

export const DELETE_ACCOUNT = "DELETE_ACCOUNT"
export const DELETE_ACCOUNT_SUCCESS = "DELETE_ACCOUNT_SUCCESS"
export const DELETE_ACCOUNT_FAIL = "DELETE_ACCOUNT_FAIL"

export const USER_MANAGEMENT = {
  GET_ABILITY_LIST: "GET_ABILITY_LIST",
  GET_ABILITY_LIST_SUCCESS: "GET_ABILITY_LIST_SUCCESS",
  GET_ABILITY_LIST_FAIL: "GET_ABILITY_LIST_FAIL",

  GET_ABILITY_LIST_BY_USER: "GET_ABILITY_LIST_BY_USER",
  GET_ABILITY_LIST_BY_USER_SUCCESS: "GET_ABILITY_LIST_BY_USER_SUCCESS",
  GET_ABILITY_LIST_BY_USER_FAIL: "GET_ABILITY_LIST_BY_USER_FAIL",

  GET_ROLE_LIST: "GET_ROLE_LIST",
  GET_ROLE_LIST_SUCCESS: "GET_ROLE_LIST_SUCCESS",
  GET_ROLE_LIST_FAIL: "GET_ROLE_LIST_FAIL",

  GET_ROLE_LIST_BY_USER: "GET_ROLE_LIST_BY_USER",
  GET_ROLE_LIST_BY_USER_SUCCESS: "GET_ROLE_LIST_BY_USER_SUCCESS",
  GET_ROLE_LIST_BY_USER_FAIL: "GET_ROLE_LIST_BY_USER_FAIL",

  GET_USER_LIST: "GET_USER_LIST",
  GET_USER_LIST_SUCCESS: "GET_USER_LIST_SUCCESS",
  GET_USER_LIST_FAIL: "GET_USER_LIST_FAIL",

  GET_USER_LIST_BY_ROLE: "GET_USER_LIST_BY_ROLE",
  GET_USER_LIST_BY_ROLE_SUCCESS: "GET_USER_LIST_BY_ROLE_SUCCESS",
  GET_USER_LIST_BY_ROLE_FAIL: "GET_USER_LIST_BY_ROLE_FAIL",

  CREATE_NEW_ROLE: "CREATE_NEW_ROLE",
  CREATE_NEW_ROLE_SUCCESS: "CREATE_NEW_ROLE_SUCCESS",
  CREATE_NEW_ROLE_FAIL: "CREATE_NEW_ROLE_FAIL",

  DELETE_ROLE: "DELETE_ROLE",
  DELETE_ROLE_SUCCESS: "DELETE_ROLE_SUCCESS",
  DELETE_ROLE_FAIL: "DELETE_ROLE_FAIL",

  DELETE_USER: "DELETE_USER",
  DELETE_USER_SUCCESS: "DELETE_USER_SUCCESS",
  DELETE_USER_FAIL: "DELETE_USER_FAIL",

  UPDATE_USER_INFORMATION: "UPDATE_USER_INFORMATION",
  UPDATE_USER_INFORMATION_SUCCESS: "UPDATE_USER_INFORMATION_SUCCESS",
  UPDATE_USER_INFORMATION_FAIL: "UPDATE_USER_INFORMATION_FAIL",

  UPDATE_USER_ROLES: "UPDATE_USER_ROLES",
  UPDATE_USER_ROLES_SUCCESS: "UPDATE_USER_ROLES_SUCCESS",
  UPDATE_USER_ROLES_FAIL: "UPDATE_USER_ROLES_FAIL",
  

  UPDATE_ROLE_INFORMATION: "UPDATE_ROLE_INFORMATION",
  UPDATE_ROLE_INFORMATION_SUCCESS: "UPDATE_ROLE_INFORMATION_SUCCESS",
  UPDATE_ROLE_INFORMATION_FAIL: "UPDATE_ROLE_INFORMATION_FAIL",

  UPDATE_ROLE_ABILITIES: "UPDATE_ROLE_ABILITIES",
  UPDATE_ROLE_ABILITIES_SUCCESS: "UPDATE_ROLE_ABILITIES_SUCCESS",
  UPDATE_ROLE_ABILITIES_FAIL: "UPDATE_ROLE_ABILITIES_FAIL",

  // Set default warehouse for users
  SET_DEFAULT_WAREHOUSE: "SET_DEFAULT_WAREHOUSE",
  SET_DEFAULT_WAREHOUSE_SUCCESS: "SET_DEFAULT_WAREHOUSE_SUCCESS",
  SET_DEFAULT_WAREHOUSE_FAIL: "SET_DEFAULT_WAREHOUSE_FAIL",

  GET_DEFAULT_WAREHOUSE: "GET_DEFAULT_WAREHOUSE",
  GET_DEFAULT_WAREHOUSE_SUCCESS: "GET_DEFAULT_WAREHOUSE_SUCCESS",
  GET_DEFAULT_WAREHOUSE_FAIL: "GET_DEFAULT_WAREHOUSE_FAIL",
}

// Postal codes export
export const GET_POST_CODE_IN_POLYGON = 'GET_POST_CODE_IN_POLYGON'
export const GET_POST_CODE_IN_POLYGON_SUCCESS = 'GET_POST_CODE_IN_POLYGON_SUCCESS'
export const GET_POST_CODE_IN_POLYGON_FAIL = 'GET_POST_CODE_IN_POLYGON_FAIL'

export const GET_POST_CODE_IN_CIRCLE = 'GET_POST_CODE_IN_CIRCLE'
export const GET_POST_CODE_IN_CIRCLE_SUCCESS = 'GET_POST_CODE_IN_CIRCLE_SUCCESS'
export const GET_POST_CODE_IN_CIRCLE_FAIL = 'GET_POST_CODE_IN_CIRCLE_FAIL'

// local delivery count report ldcr
export const LOCAL_ORDER_COUNT = "LOCAL_ORDER_COUNT"
export const LOCAL_ORDER_COUNT_SUCCESS = "LOCAL_ORDER_COUNT_SUCCESS"
export const LOCAL_ORDER_COUNT_FAIL = "LOCAL_ORDER_COUNT_FAIL"

// Service point
export const GET_SERVICE_POINT = "GET_SERVICE_POINT"
export const GET_SERVICE_POINT_SUCCESS = "GET_SERVICE_POINT_SUCCESS"
export const GET_SERVICE_POINT_FAIL = "GET_SERVICE_POINT_FAIL"

export const GET_DRIVER_SERVICE_POINT = "GET_DRIVER_SERVICE_POINT"
export const GET_DRIVER_SERVICE_POINT_SUCCESS = "GET_DRIVER_SERVICE_POINT_SUCCESS"
export const GET_DRIVER_SERVICE_POINT_FAIL = "GET_DRIVER_SERVICE_POINT_FAIL"

export const ASSIGN_SERVICE_POINT = "ASSIGN_SERVICE_POINT"
export const ASSIGN_SERVICE_POINT_SUCCESS = "ASSIGN_SERVICE_POINT_SUCCESS"
export const ASSIGN_SERVICE_POINT_FAIL = "ASSIGN_SERVICE_POINT_FAIL"

// driver app approval
export const GET_INDIVIDUAL = "GET_INDIVIDUAL"
export const GET_INDIVIDUAL_SUCCESS = "GET_INDIVIDUAL_SUCCESS"
export const GET_INDIVIDUAL_FAIL = "GET_INDIVIDUAL_FAIL"

export const GET_PROFILE = "GET_PROFILE"
export const GET_PROFILE_SUCCESS = "GET_PROFILE_SUCCESS"
export const GET_PROFILE_FAIL = "GET_PROFILE_FAIL"

export const GET_VEHICLE_TYPE = "GET_VEHICLE_TYPE"
export const GET_VEHICLE_TYPE_SUCCESS = "GET_VEHICLE_TYPE_SUCCESS"
export const GET_VEHICLE_TYPE_FAIL = "GET_VEHICLE_TYPE_FAIL"

export const GET_DELIVERY_AREAS = "GET_DELIVERY_AREAS"
export const GET_DELIVERY_AREAS_SUCCESS = "GET_DELIVERY_AREAS_SUCCESS"
export const GET_DELIVERY_AREAS_FAIL = "GET_DELIVERY_AREAS_FAIL"

export const GET_INDIVIDUAL_DOCUMENT = "GET_INDIVIDUAL_DOCUMENT"
export const GET_INDIVIDUAL_DOCUMENT_SUCCESS = "GET_INDIVIDUAL_DOCUMENT_SUCCESS"
export const GET_INDIVIDUAL_DOCUMENT_FAIL = "GET_INDIVIDUAL_DOCUMENT_FAIL"

export const GET_DRIVER_BY_ID = "GET_DRIVER_BY_ID"
export const GET_DRIVER_BY_ID_SUCCESS = "GET_DRIVER_BY_ID_SUCCESS"
export const GET_DRIVER_BY_ID_FAIL = "GET_DRIVER_BY_ID_FAIL"

export const EDIT_PROFILE = "EDIT_PROFILE"
export const EDIT_PROFILE_SUCCESS = "EDIT_PROFILE_SUCCESS"
export const EDIT_PROFILE_FAIL = "EDIT_PROFILE_FAIL"

export const GET_CITY_LIST = "GET_CITY_LIST"
export const GET_CITY_LIST_SUCCESS = "GET_CITY_LIST_SUCCESS"
export const GET_CITY_LIST_FAIL = "GET_CITY_LIST_FAIL"

export const GET_REVIEW_COUNT = "GET_REVIEW_COUNT"
export const GET_REVIEW_COUNT_SUCCESS = "GET_REVIEW_COUNT_SUCCESS"
export const GET_REVIEW_COUNT_FAIL = "GET_REVIEW_COUNT_FAIL"

export const PUT_REVIEW_RESULT = "PUT_REVIEW_RESULT"
export const PUT_REVIEW_RESULT_SUCCESS = "PUT_REVIEW_RESULT_SUCCESS"
export const PUT_REVIEW_RESULT_FAIL = "PUT_REVIEW_RESULT_FAIL"

export const SWITCH_SORTING_SCAN = "SWITCH_SORTING_SCAN"
export const SWITCH_SORTING_SCAN_SUCCESS = "SWITCH_SORTING_SCAN_SUCCESS"
export const SWITCH_SORTING_SCAN_FAIL = "SWITCH_SORTING_SCAN_FAIL"

export const GET_PROVINCE_COUNTRY_BY_WAREHOUSE = "GET_PROVINCE_COUNTRY_BY_WAREHOUSE"
export const GET_PROVINCE_COUNTRY_BY_WAREHOUSE_SUCCESS = "GET_PROVINCE_COUNTRY_BY_WAREHOUSE_SUCCESS"
export const GET_PROVINCE_COUNTRY_BY_WAREHOUSE_FAIL = "GET_PROVINCE_COUNTRY_BY_WAREHOUSE_FAIL"

export const GET_DELIVERY_AREAS_BY_WAREHOUSE = "GET_DELIVERY_AREAS_BY_WAREHOUSE"
export const GET_DELIVERY_AREAS_BY_WAREHOUSE_SUCCESS = "GET_DELIVERY_AREAS_BY_WAREHOUSE_SUCCESS"
export const GET_DELIVERY_AREAS_BY_WAREHOUSE_FAIL = "GET_DELIVERY_AREAS_BY_WAREHOUSE_FAIL"

export const SET_DOUBLE_CHECK = "SET_DOUBLE_CHECK"
export const SET_DOUBLE_CHECK_SUCCESS = "SET_DOUBLE_CHECK_SUCCESS"
export const SET_DOUBLE_CHECK_FAIL = "SET_DOUBLE_CHECK_FAIL"

export const DELETE_DOUBLE_CHECK = "DELETE_DOUBLE_CHECK"
export const DELETE_DOUBLE_CHECK_SUCCESS = "DELETE_DOUBLE_CHECK_SUCCESS"
export const DELETE_DOUBLE_CHECK_FAIL = "DELETE_DOUBLE_CHECK_FAIL"

export const GET_DOUBLE_CHECK = "GET_DOUBLE_CHECK"
export const GET_DOUBLE_CHECK_SUCCESS = "GET_DOUBLE_CHECK_SUCCESS"
export const GET_DOUBLE_CHECK_FAIL = "GET_DOUBLE_CHECK_FAIL"

export const GET_FUEL_TYPE = "GET_FUEL_TYPE"
export const GET_FUEL_TYPE_SUCCESS = "GET_FUEL_TYPE_SUCCESS"
export const GET_FUEL_TYPE_FAIL = "GET_FUEL_TYPE_FAIL"

// Pre Alert Management
export const CREATE_SUB_BATCH_NEW_PRE = "CREATE_SUB_BATCH_NEW"
export const CREATE_SUB_BATCH_NEW_PRE_SUCCESS = "CREATE_SUB_BATCH_NEW_SUCCESS"
export const CREATE_SUB_BATCH_NEW_PRE_FAIL = "CREATE_SUB_BATCH_NEW_FAIL"

export const GET_COUNTRY_LIST = "GET_COUNTRY_LIST"
export const GET_COUNTRY_LIST_SUCCESS = "GET_COUNTRY_LIST_SUCCESS"
export const GET_COUNTRY_LIST_FAIL = "GET_COUNTRY_LIST_FAIL"

export const GET_PROVINCE_LIST = "GET_PROVINCE_LIST"
export const GET_PROVINCE_LIST_SUCCESS = "GET_PROVINCE_LIST_SUCCESS"
export const GET_PROVINCE_LIST_FAIL = "GET_PROVINCE_LIST_FAIL"

export const CREATE_NEW_DRIVER = "CREATE_NEW_DRIVER"
export const CREATE_NEW_DRIVER_SUCCESS = "CREATE_NEW_DRIVER_SUCCESS"
export const CREATE_NEW_DRIVER_FAIL = "CREATE_NEW_DRIVER_FAIL"

export const EDIT_PROFILE_ADDITIONAL = "EDIT_PROFILE_ADDITIONAL"
export const EDIT_PROFILE_ADDITIONAL_SUCCESS = "EDIT_PROFILE_ADDITIONAL_SUCCESS"
export const EDIT_PROFILE_ADDITIONAL_FAIL = "EDIT_PROFILE_ADDITIONAL_FAIL"

export const EDIT_SALARY_TYPE = "EDIT_SALARY_TYPE"
export const EDIT_SALARY_TYPE_SUCCESS = "EDIT_SALARY_TYPE_SUCCESS"
export const EDIT_SALARY_TYPE_FAIL = "EDIT_SALARY_TYPE_FAIL"

export const GET_DRIVER_BASIC = "GET_DRIVER_BASIC"
export const GET_DRIVER_BASIC_SUCCESS = "GET_DRIVER_BASIC_SUCCESS"
export const GET_DRIVER_BASIC_FAIL = "GET_DRIVER_BASIC_FAIL"

export const EDIT_DRIVER_BASIC = "EDIT_DRIVER_BASIC"
export const EDIT_DRIVER_BASIC_SUCCESS = "EDIT_DRIVER_BASIC_SUCCESS"
export const EDIT_DRIVER_BASIC_FAIL = "EDIT_DRIVER_BASIC_FAIL"

export const GET_ACCOUNT_DOCUMENT = "GET_ACCOUNT_DOCUMENT"
export const GET_ACCOUNT_DOCUMENT_SUCCESS = "GET_ACCOUNT_DOCUMENT_SUCCESS"
export const GET_ACCOUNT_DOCUMENT_FAIL = "GET_ACCOUNT_DOCUMENT_FAIL"

export const POST_ACCOUNT_DOCUMENT = "POST_ACCOUNT_DOCUMENT"
export const POST_ACCOUNT_DOCUMENT_SUCCESS = "POST_ACCOUNT_DOCUMENT_SUCCESS"
export const POST_ACCOUNT_DOCUMENT_FAIL = "POST_ACCOUNT_DOCUMENT_FAIL"

export const GET_DRIVER_ADDITIONAL = "GET_DRIVER_ADDITIONAL"
export const GET_DRIVER_ADDITIONAL_SUCCESS = "GET_DRIVER_ADDITIONAL_SUCCESS"
export const GET_DRIVER_ADDITIONAL_FAIL = "GET_DRIVER_ADDITIONAL_FAIL"

export const GET_SALARY_TYPE_ADDITIONAL = "GET_SALARY_TYPE_ADDITIONAL"
export const GET_SALARY_TYPE_ADDITIONAL_SUCCESS = "GET_SALARY_TYPE_ADDITIONAL_SUCCESS"
export const GET_SALARY_TYPE_ADDITIONAL_FAIL = "GET_SALARY_TYPE_ADDITIONAL_FAIL"

// Resend orders
export const LOAD_RESEND_ORDERS = "LOAD_RESEND_ORDERS"
export const LOAD_RESEND_ORDERS_SUCCESS = "LOAD_RESEND_ORDERS_SUCCESS"
export const LOAD_RESEND_ORDERS_FAIL = "LOAD_RESEND_ORDERS_FAIL"

export const LABEL_PRINT = "LABEL_PRINT"
export const LABEL_PRINT_SUCCESS = "LABEL_PRINT_SUCCESS"
export const LABEL_PRINT_FAIL = "LABEL_PRINT_FAIL"

export const RESET_DRIVER_PASSWORD = "RESET_DRIVER_PASSWORD"
export const RESET_DRIVER_PASSWORD_SUCCESS = "RESET_DRIVER_PASSWORD_SUCCESS"
export const RESET_DRIVER_PASSWORD_FAIL = "RESET_DRIVER_PASSWORD_FAIL"

export const INCIDENT_MANAGEMENT = {
  GET_ALL_DROP_DOWNS: "GET_ALL_DROP_DOWNS",
  GET_ALL_DROP_DOWNS_SUCCESS: "GET_ALL_DROP_DOWNS_SUCCESS",
  GET_ALL_DROP_DOWNS_FAIL: "GET_ALL_DROP_DOWNS_FAIL",
  GET_INVESTIGATIONS: "GET_INVESTIGATIONS",
  GET_INVESTIGATIONS_SUCCESS: "GET_INVESTIGATIONS_SUCCESS",
  GET_INVESTIGATIONS_FAIL: "GET_INVESTIGATIONS_FAIL",
  CREATE_NEW_INCIDENT: "CREATE_NEW_INCIDENT",
  CREATE_NEW_INCIDENT_SUCCESS: "CREATE_NEW_INCIDENT_SUCCESS",
  CREATE_NEW_INCIDENT_FAIL: "CREATE_NEW_INCIDENT_FAIL",
  UPDATE_BASIC_INCIDENT: "UPDATE_BASIC_INCIDENT",
  UPDATE_BASIC_INCIDENT_SUCCESS: "UPDATE_BASIC_INCIDENT_SUCCESS",
  UPDATE_BASIC_INCIDENT_FAIL: "UPDATE_BASIC_INCIDENT_FAIL",
  UPDATE_INPROGRESS_INCIDENT: "UPDATE_INPROGRESS_INCIDENT",
  UPDATE_INPROGRESS_INCIDENT_SUCCESS: "UPDATE_INPROGRESS_INCIDENT_SUCCESS",
  UPDATE_INPROGRESS_INCIDENT_FAIL: "UPDATE_INPROGRESS_INCIDENT_FAIL",
  CLOSE_INVESTIGATION: "CLOSE_INVESTIGATION",
  CLOSE_INVESTIGATION_SUCCESS: "CLOSE_INVESTIGATION_SUCCESS",
  CLOSE_INVESTIGATION_FAIL: "CLOSE_INVESTIGATION_FAIL",
  BATCH_UPLOAD_INVESTIGATION: "BATCH_UPLOAD_INVESTIGATION",
  BATCH_UPLOAD_INVESTIGATION_SUCCESS: "BATCH_UPLOAD_INVESTIGATION_SUCCESS",
  BATCH_UPLOAD_INVESTIGATION_FAIL: "BATCH_UPLOAD_INVESTIGATION_FAIL",
  GET_WAREHOUSE_INCIDENT_COUNT: "GET_WAREHOUSE_INCIDENT_COUNT",
  GET_WAREHOUSE_INCIDENT_COUNT_SUCCESS: "GET_WAREHOUSE_INCIDENT_COUNT_SUCCESS",
  GET_WAREHOUSE_INCIDENT_COUNT_FAIL: "GET_WAREHOUSE_INCIDENT_COUNT_FAIL",
  BATCH_CLOSE_INCIDENT: "BATCH_CLOSE_INCIDENT",
  BATCH_CLOSE_INCIDENT_SUCCESS: "BATCH_CLOSE_INCIDENT_SUCCESS",
  BATCH_CLOSE_INCIDENT_FAIL: "BATCH_CLOSE_INCIDENT_FAIL",
  DOWNLOAD_INCIDENT_EXCEL: "DOWNLOAD_INCIDENT_EXCEL",
  DOWNLOAD_INCIDENT_EXCEL_SUCCESS: "DOWNLOAD_INCIDENT_EXCEL_SUCCESS",
  DOWNLOAD_INCIDENT_EXCEL_FAIL: "DOWNLOAD_INCIDENT_EXCEL_FAIL",
  BATCH_PROGRESS_INCIDENT: "BATCH_PROGRESS_INCIDENT",
  BATCH_PROGRESS_INCIDENT_SUCCESS: "BATCH_PROGRESS_INCIDENT_SUCCESS",
  BATCH_PROGRESS_INCIDENT_FAIL: "BATCH_PROGRESS_INCIDENT_FAIL",
  SEARCH_KEY_ACCOUNT: "SEARCH_KEY_ACCOUNT",
  SEARCH_KEY_ACCOUNT_SUCCESS: "SEARCH_KEY_ACCOUNT_SUCCESS",
  SEARCH_KEY_ACCOUNT_FAIL: "SEARCH_KEY_ACCOUNT_FAIL",
  CREATE_KEY_ACCOUNT: "CREATE_KEY_ACCOUNT",
  CREATE_KEY_ACCOUNT_SUCCESS: "CREATE_KEY_ACCOUNT_SUCCESS",
  CREATE_KEY_ACCOUNT_FAIL: "CREATE_KEY_ACCOUNT_FAIL",
  UPDATE_KEY_ACCOUNT: "UPDATE_KEY_ACCOUNT",
  UPDATE_KEY_ACCOUNT_SUCCESS: "UPDATE_KEY_ACCOUNT_SUCCESS",
  UPDATE_KEY_ACCOUNT_FAIL: "UPDATE_KEY_ACCOUNT_FAIL",
  DELETE_KEY_ACCOUNT: "DELETE_KEY_ACCOUNT",
  DELETE_KEY_ACCOUNT_SUCCESS: "DELETE_KEY_ACCOUNT_SUCCESS",
  CDELETE_KEY_ACCOUNT_FAIL: "DELETE_KEY_ACCOUNT_FAIL",
  SEARCH_COMPENSATED_ORDER: "SEARCH_COMPENSATED_ORDER",
  SEARCH_COMPENSATED_ORDER_SUCCESS: "SEARCH_COMPENSATED_ORDER_SUCCESS",
  SEARCH_COMPENSATED_ORDERT_FAIL: "SEARCH_COMPENSATED_ORDER_FAIL",
  SEARCH_MULTIPLE_ORDER: "SEARCH_MULTIPLE_ORDER",
  SEARCH_MULTIPLE_ORDER_SUCCESS: "SEARCH_MULTIPLE_ORDER_SUCCESS",
  SEARCH_MUTIPLE_ORDERT_FAIL: "SEARCH_MUTIPLE_ORDERT_FAIL",
  DOWNLOAD_COMPENSATED_ORDER: "DOWNLOAD_COMPENSATED_ORDER",
  DOWNLOAD_COMPENSATED_ORDER_SUCCESS: "DOWNLOAD_COMPENSATED_ORDER_SUCCESS",
  DOWNLOAD_COMPENSATED_ORDER_FAIL: "DOWNLOAD_COMPENSATED_ORDER_FAIL",
}

export const COMMON = {
  GET_ALL_USERS: "GET_ALL_USERS",
  GET_ALL_USERS_SUCCESS: "GET_ALL_USERS_SUCCESS",
  GET_ALL_USERS_FAIL: "GET_ALL_USERS_FAIL",
}

export const GET_ORDERS_AND_CHECK_INPUT = "GET_ORDERS_AND_CHECK_INPUT"
export const GET_ORDERS_AND_CHECK_INPUT_SUCCESS = "GET_ORDERS_AND_CHECK_INPUT_SUCCESS"
export const GET_ORDERS_AND_CHECK_INPUT_FAIL = "GET_ORDERS_AND_CHECK_INPUT_FAIL"

export const SUB_BATCH_UPDATE_STATUS = 'SUB_BATCH_UPDATE_STATUS'
export const SUB_BATCH_UPDATE_STATUS_SUCCESS = 'SUB_BATCH_UPDATE_STATUS_SUCCESS'
export const SUB_BATCH_UPDATE_STATUS_FAIL = 'SUB_BATCH_UPDATE_STATUS_FAIL'

export const UPDATE_NOTES_BY_TNOS = 'UPDATE_NOTES_BY_TNOS'
export const UPDATE_NOTES_BY_TNOS_SUCCESS = 'UPDATE_NOTES_BY_TNOS_SUCCESS'
export const UPDATE_NOTES_BY_TNOS_FAIL = 'UPDATE_NOTES_BY_TNOS_FAIL'

export const DRIVER_PICKUP = {
  GET_PICKUP_ORDER: "GET_PICKUP_ORDER",
  GET_PICKUP_ORDER_SUCCESS: "GET_PICKUP_ORDER_SUCCESS",
  GET_PICKUP_ORDER_FAIL: "GET_PICKUP_ORDER_FAIL",

  GET_ORDER_BY_MANIFEST_NO: "GET_ORDER_BY_MANIFEST_NO",
  GET_ORDER_BY_MANIFEST_NO_SUCCESS: "GET_ORDER_BY_MANIFEST_NO_SUCCESS",
  GET_ORDER_BY_MANIFEST_NO_FAIL: "GET_ORDER_BY_MANIFEST_NO_FAIL",

  GET_MANIFEST_LIST: "GET_MANIFEST_LIST",
  GET_MANIFEST_LIST_SUCCESS: "GET_MANIFEST_LIST_SUCCESS",
  GET_MANIFEST_LIST_FAIL: "GET_MANIFEST_LIST_FAIL",
  
  CREATE_PICKUP_MANIFEST: "CREATE_PICKUP_MANIFEST",
  CREATE_PICKUP_MANIFEST_SUCCESS: "CREATE_PICKUP_MANIFEST_SUCCESS",
  CREATE_PICKUP_MANIFEST_FAIL: "CREATE_PICKUP_MANIFEST_FAIL",

  ASSIGN_MANIFEST_TO_DRIVER: "ASSIGN_MANIFEST_TO_DRIVER",
  ASSIGN_MANIFEST_TO_DRIVER_SUCCESS: "ASSIGN_MANIFEST_TO_DRIVER_SUCCESS",
  ASSIGN_MANIFEST_TO_DRIVER_FAIL: "ASSIGN_MANIFEST_TO_DRIVER_FAIL",

  GET_PICKUP_PARTNER: "GET_PICKUP_PARTNER",
  GET_PICKUP_PARTNER_SUCCESS: "GET_PICKUP_PARTNER_SUCCESS",
  GET_PICKUP_PARTNER_FAIL: "GET_PICKUP_PARTNER_FAIL",

  GET_PICKUP_WAREHOUSE: "GET_PICKUP_WAREHOUSE",
  GET_PICKUP_WAREHOUSE_SUCCESS: "GET_PICKUP_WAREHOUSE_SUCCESS",
  GET_PICKUP_WAREHOUSE_FAIL: "GET_PICKUP_WAREHOUSE_FAIL"
}

export const POD_QUALITY = {
  DOWNLOAD_POD_QUALITY_EXCEL: "DOWNLOAD_POD_QUALITY_EXCEL",
  DOWNLOAD_POD_QUALITY_EXCEL_SUCCESS: "DOWNLOAD_POD_QUALITY_EXCEL_SUCCESS",
  DOWNLOAD_POD_QUALITY_EXCEL_FAIL: "DOWNLOAD_POD_QUALITY_EXCEL_FAIL"
}

export const SELF_PICKUP = {
  HANDLE_VALID_TNOS: "HANDLE_VALID_TNOS",
  SAVE_SEARCH_TNOS: "SAVE_SEARCH_TNOS",
  HANDLE_SCANNED_TNOS: "HANDLE_SCANNED_TNOS",
  HANDLE_SIGNATURE: "HANDLE_SIGNATURE",

  CUSTOMER_PICKUP_UPDATE: "CUSTOMER_PICKUP_UPDATE",
  CUSTOMER_PICKUP_UPDATE_SUCCESS: "CUSTOMER_PICKUP_UPDATE_SUCCESS",
  CUSTOMER_PICKUP_UPDATE_FAIL: "CUSTOMER_PICKUP_UPDATE_FAIL"
}

export const SORTING_MACHINE = {
  GET_ALL_ROUTES: "GET_ALL_ROUTES",
  GET_ALL_ROUTES_SUCCESS: "GET_ALL_ROUTES_SUCCESS",
  GET_ALL_ROUTES_FAIL: "GET_ALL_ROUTES_FAIL",

  QUERY_SORTING_CONFIGS: "QUERY_SORTING_CONFIGS",
  QUERY_SORTING_CONFIGS_SUCCESS: "QUERY_SORTING_CONFIGS_SUCCESS",
  QUERY_SORTING_CONFIGS_FAIL: "QUERY_SORTING_CONFIGS_FAIL",

  ADD_SORTING_CONFIG: "ADD_SORTING_CONFIG",
  ADD_SORTING_CONFIG_SUCCESS: "ADD_SORTING_CONFIG_SUCCESS",
  ADD_SORTING_CONFIG_FAIL: "ADD_SORTING_CONFIG_FAIL",

  UPDATE_SORTING_CONFIG: "UPDATE_SORTING_CONFIG",
  UPDATE_SORTING_CONFIG_SUCCESS: "UPDATE_SORTING_CONFIG_SUCCESS",
  UPDATE_SORTING_CONFIG_FAIL: "UPDATE_SORTING_CONFIG_FAIL",

  SET_CURRENT_PLAN: "SET_CURRENT_PLAN",
  SET_CURRENT_PLAN_SUCCESS: "SET_CURRENT_PLAN_SUCCESS",
  SET_CURRENT_PLAN_FAIL: "SET_CURRENT_PLAN_FAIL",

  GET_SORTING_MACHINES: "GET_SORTING_MACHINES",
  GET_SORTING_MACHINES_SUCCESS: "GET_SORTING_MACHINES_SUCCESS",
  GET_SORTING_MACHINES_FAIL: "GET_SORTING_MACHINES_FAIL",

  GET_SORTING_WAREHOUSES: "GET_SORTING_WAREHOUSES",
  GET_SORTING_WAREHOUSES_SUCCESS: "GET_SORTING_WAREHOUSES_SUCCESS",
  GET_SORTING_WAREHOUSES_FAIL: "GET_SORTING_WAREHOUSES_FAIL",

  HANDLE_ROUTES_UPDATE: "HANDLE_ROUTES_UPDATE",

  HANDLE_SEARCH_ITEMS: "HANDLE_SEARCH_ITEMS",

  HANDLE_PRESET: "HANDLE_PRESET",

  GET_MACHINE_SLOTS: "GET_MACHINE_SLOTS",
  GET_MACHINE_SLOTS_SUCCESS: "GET_MACHINE_SLOTS_SUCCESS",
  GET_MACHINE_SLOTS_FAIL: "GET_MACHINE_SLOTS_FAIL",

  DELETE_SORTING_CONFIG: "DELETE_SORTING_CONFIG",
  DELETE_SORTING_CONFIG_SUCCESS: "DELETE_SORTING_CONFIG_SUCCESS",
  DELETE_SORTING_CONFIG_FAIL: "DELETE_SORTING_CONFIG_FAIL",

  HANDLE_CURRENT_CONFIG: "HANDLE_CURRENT_CONFIG"
}